<template>
  <div class="en-flow">
    <div @click="click" style="width:100%;height:100%"></div>
    <div class="show-list-level1" v-if="showList">
            <div class="title">
        <i
          class="close-icon el-icon el-icon-close"
          @click="showList = false"
        ></i>
        审批流程
      </div>
      <div class="show-list-container">
        <en-flow-node
          v-for="(item, index) in list"
          :key="index"
          :data="item"
          :info="fullData"
        >
        </en-flow-node>
      </div>
    </div>
  </div>
</template>
<script>

import enFlowNode from './en-flow-node'

export default {
  name: 'en-flow',
  components: { enFlowNode },
  props: {
    commondata: Object,
    fullData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: this.fullData.data,
      showList: false,
    }
  },
  watch: {
    showList(val) {
      if (val) {
        document.getElementsByClassName('business-model')[0].style.overflow =
          'hidden'
      } else {
        document.getElementsByClassName('business-model')[0].style.overflow =
          'auto'
      }
    },
  },
  methods: {
    click() {
      this.showList = !this.showList
    }
  },
}
</script>
<style lang="scss">
.en-flow {
  width: 100%;
  height: 100%;
  position: relative;
  .show-list-level1 {
    position: fixed;
    z-index: 8;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #f7f7f7;

    .title {
      text-align: center;
      color: #ffffff;
      position: relative;
      width: 100%;
      height: 50px;
      line-height: 50px;
      background-color: #31415a;

      .close-icon {
        position: absolute;
        font-size: 32px;
        top: 9px;
        left: 9px;
      }
    }

    .show-list-container {
      margin-top: 20px;
      margin-right: 15px;
      height: calc(100% - 50px);
      overflow: auto;
      position: relative;
      z-index: 3;
    }
  }
}
</style>
